export const validateProjectName = (value: string) => {
  if (!value.trim()) return 'Project name is required';
  if (value.length > 50) return 'Maximum 50 characters allowed';
  if (!/^[a-zA-Z0-9_]+$/.test(value)) {
    return 'Only letters, numbers, and underscores (_) are allowed';
  }
  return true;
};

export const validateAlphaCode = (value: string) => {
  if (!value) return 'alpha code is required';

  if (value.length > 16) {
    return 'Maximum 16 characters allowed';
  }

  // Regex: only letters, numbers, and underscore, no spaces or other special chars
  const regex = /^[A-Za-z0-9_]+$/;
  if (!regex.test(value)) {
    return 'Only letters, numbers, and underscores are allowed; no spaces or special characters';
  }

  return true;
};

export function validateName(value: string) {
  if (!value || value.trim() === '') {
    return 'Project name is required';
  }
  if (value.length > 50) {
    return 'Maximum 50 characters allowed';
  }
  if (!/^[a-zA-Z0-9_]*$/.test(value)) {
    return 'Only letters, numbers, and underscores are allowed';
  }
  return true;
}

export const initialOptions = [
  {key: 'users', label: 'Users', checked: true, disabled: false},
  {
    key: 'savedSearches',
    label: 'Saved Searches',
    checked: true,
    disabled: false,
  },
  {key: 'assignments', label: 'Assignments', checked: true, disabled: false},
  {
    key: 'assignedReviewers',
    label: 'Assigned Reviewers',
    checked: true,
    disabled: false,
  },
  {
    key: 'customReports',
    label: 'Custom Reports',
    checked: false,
    disabled: false,
  },
];

export const validateFolderPath = (
  value: string,
  type?: 'project' | 'ingestion' | 'production'
) => {
  if (!value.trim()) {
    switch (type) {
      case 'project':
        return 'You must specify the project folder';
      case 'ingestion':
        return 'You must specify the ingestion folder';
      case 'production':
        return 'You must specify the production folder';
      default:
        return 'This field is required';
    }
  }

  const regex = /^[a-zA-Z0-9-_\\ ]+$/;
  if (!regex.test(value)) {
    return 'You cannot specify any special characters in the field value';
  }

  return true;
};

export type KeyValue = {
  id: number;
  label: string;
};

export const defaultToggles = [
  {
    key: 'projectServer',
    label: 'Enable Project Server Path',
    checked: true,
    disabled: false,
  },
  {
    key: 'ingestionServer',
    label: 'Enable Ingestion Server Path',
    checked: true,
    disabled: false,
  },
  {
    key: 'productionServer',
    label: 'Enable Production Server Path',
    checked: true,
    disabled: false,
  },
];

export const availableComponentList: KeyValue[] = [
  {id: 1, label: 'Textual Analytics'},
];

export const baseAutomationList: KeyValue[] = [
  {id: 2, label: 'Kick off Analytics Automatically'},
  {id: 3, label: 'Run Incremental Analytics for New Small Data (<20%)'},
];

export const displayedGenerativeAIList = [
  {id: 0, label: 'AI Investigate'},
  {id: 1, label: 'AI Review'},
  {id: 2, label: 'AI Batch Summarize'},
];
